import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/customs/circuit',
}).lazy(() => import('./circuit.lazy').then((d) => d.Route))
